import alt from '../alt';


class NotificationSettingActions {
    constructor() {
        this.generateActions('updatedSettingsSuccess', 'getSettingsSuccess', 'clearNotificationSettingLoaded');
    }

}

export default alt.createActions(NotificationSettingActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/NotificationSettingActions.js
 **/